import { AxiosInstance } from 'axios'

import { BaseAPI } from '../../classes/BaseAPI'

export class SettingsAPI extends BaseAPI {
  constructor(axios: AxiosInstance) {
    super(axios)
  }

  // IEU.11 — public read of the admin-configured inactivity timeout (minutes),
  // used to drive the client-side idle-logout timer.
  async getInactivityTimeoutMinutes() {
    return await this.request<{ inactivityTimeoutMinutes: number }>('/settings/session/inactivity-timeout/public', 'GET')
  }
}
